module.exports = __webpack_public_path__ + "static/media/flood1.09dfc1c8.png";